import React, { useState, useEffect, useRef } from 'react'
import { Button, Collapse, Nav } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'
import dynamic from 'next/dynamic'
//

import styles from '@shared/components/fixtureContent/style.module.scss'
import formStyles from '@assets/scss/components/form.module.scss'
import navStyles from '@shared/components/commonNav/style.module.scss'
import { CURRENT_MATCHES, FIXTURE_FILTER } from '@graphql/fixtures/fixtures.query'
import { monthCal, currentMonthYear, decodeMonth, getTimeZone, isBottomReached } from '@shared-submodule/utils'
import NameFilter from '../fixtureContent/nameFilter'
import { FilterIcon } from '../ctIcons'
import { fixtureLoader } from '@shared/libs/allLoader'

const DateSlider = dynamic(() => import('@shared/components/dateSlider'))
const FixtureData = dynamic(() => import('@shared/components/fixtureContent/fixtureData'))
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

export default function ScheduleContent({ data, filterData }) {
  const [fixtureData, setFixtureData] = useState(data?.listAllFixtures)
  const [newFilterData, setNewFilterData] = useState(filterData)
  const payloads = useRef({ eCategory: 'i', dByMonth: currentMonthYear(), sTimezone: getTimeZone(), nLimit: 10, nSkip: 1 })
  const filterPayloads = useRef({ eCategory: 'i', dByMonth: currentMonthYear(), sTimezone: getTimeZone(), iTeamId: null, iSeriesId: null, iVenueId: null })
  const month = []
  const isReachedBottom = useRef(false)
  const loadingData = useRef(false)
  const monthArray = monthCal(month)
  const [open, setOpen] = useState(false)
  // const [toggleFilter, setToggleFilter] = useState(false)
  const [updateScheduleMatch, { data: updateScheduleMatchData, loading }] = useLazyQuery(CURRENT_MATCHES)
  const [updateFilter, { data: updateFilterData }] = useLazyQuery(FIXTURE_FILTER)
  const [sLabel, setSLable] = useState('i')
  const MATCH_TYPE = [
    {
      sValue: 'i',
      sLabel: 'International'
    },
    {
      sValue: 'l',
      sLabel: 'League'
    },
    {
      sValue: 'd',
      sLabel: 'Domestic'
    }
  ]

  const latestScheduleMatch = useRef(updateScheduleMatchData?.listAllFixtures?.length || data?.listAllFixtures?.length)

  // const handleFilter = () => {
  //   setToggleFilter(!toggleFilter)
  // }

  const handleCategoryFilter = (value) => {
    setSLable(value)
    payloads.current = { ...payloads.current, eCategory: value, nSkip: 1 }
    filterPayloads.current = { ...filterPayloads.current, eCategory: value }
    update()
  }

  const handleYear = (value) => {
    payloads.current = { ...payloads.current, dByMonth: decodeMonth(value), nSkip: 1 }
    filterPayloads.current = { ...filterPayloads.current, dByMonth: decodeMonth(value) }
    update()
  }

  const handleClear = () => {
    payloads.current = { ...payloads.current, iVenueId: null, iSeriesId: null, iTeamId: null, nSkip: 1 }
    filterPayloads.current = { ...filterPayloads.current, iVenueId: null, iSeriesId: null, iTeamId: null }
    update()
  }

  const handleFilterChange = (data, type) => {
    if (type === 'venue') {
      payloads.current = { ...payloads.current, iVenueId: data === null ? null : data.sValue, nSkip: 1 }
      filterPayloads.current = { ...filterPayloads.current, iVenueId: data === null ? null : data.sValue }
    } else if (type === 'team') {
      payloads.current = { ...payloads.current, iTeamId: data === null ? null : data.sValue, nSkip: 1 }
      filterPayloads.current = { ...filterPayloads.current, iTeamId: data === null ? null : data.sValue }
    } else if (type === 'series') {
      payloads.current = { ...payloads.current, iSeriesId: data === null ? null : data.sValue, nSkip: 1 }
      filterPayloads.current = { ...filterPayloads.current, iSeriesId: data === null ? null : data.sValue }
    }
    update()
  }

  function update() {
    updateScheduleMatch({ variables: { input: { ...payloads.current } } })
    updateFilter({ variables: { input: filterPayloads.current } })
  }

  useEffect(() => {
    loadingData.current = false
    isBottomReached(fixtureData[fixtureData.length - 1]?._id, isReached)
  }, [fixtureData])

  function isReached(reach) {
    if (reach && !loadingData.current && latestScheduleMatch.current === payloads.current.nLimit) {
      loadingData.current = true
      isReachedBottom.current = true
      payloads.current = ({ ...payloads.current, nSkip: payloads.current.nSkip + 1 })
      updateScheduleMatch({ variables: { input: payloads.current } })
    }
  }

  useEffect(() => {
    if (isReachedBottom.current && updateScheduleMatchData) {
      setFixtureData([...fixtureData, ...updateScheduleMatchData?.listAllFixtures])
      loadingData.current = false
      isReachedBottom.current = false
    } else if (!loading.current && updateScheduleMatchData) {
      setFixtureData(updateScheduleMatchData?.listAllFixtures)
    }
    latestScheduleMatch.current = updateScheduleMatchData?.listAllFixtures?.length >= 0 ? updateScheduleMatchData?.listAllFixtures?.length : false || data?.listAllFixtures?.length
  }, [updateScheduleMatchData])

  useEffect(() => {
    if (updateFilterData) {
      setNewFilterData(updateFilterData?.listAllFixturesFilter)
    }
  }, [updateFilterData])

  useEffect(() => {
    updateFilter({ variables: { input: filterPayloads.current } })
  }, [])

  return (
    <div className="position-relative">
      <Button
        onClick={() => setOpen(!open)}
        aria-controls="example-collapse-text"
        aria-expanded={open}
        variant="link"
        // className={`${styles.filterBtn} ct-border rounded-circle d-none d-md-inline-block`}
        className={`${styles.filterBtn} ct-border rounded-circle d-none`}
      >
        <FilterIcon />
      </Button>
      <Collapse in={open}>
        <div className={`${styles.fixturesFilter}`}>
          <div className={`${styles.bottomFilter} d-none d-md-flex flex-column flex-md-row justify-content-between mb-3`}>
            <NameFilter formStyles={formStyles} handleClear={handleClear} filterData={newFilterData} handleFilterChange={handleFilterChange} />
          </div>
        </div>
      </Collapse>
      {/* <div className={`${mobilefilter.mobFixtureFilter} ${toggleFilter && mobilefilter.active}`}>
        <div className={`${mobilefilter.head} d-flex d-md-none justify-content-between align-items-center`}>
          <p className="font-semi mb-0">
            Filter
          </p>
          <Button variant="link" onClick={handleFilter} className="btn-close"></Button>
        </div>
        <div className={`${mobilefilter.innerBlock} d-block d-md-none`}>
          <NameFilter formStyles={formStyles} mobilefilter={mobilefilter} fixtureData={fixtureData} handleClear={handleClear} filterData={newFilterData} handleFilterChange={handleFilterChange}/>
        </div>
      </div> */}
      {/* <Button
        variant="link"
        onClick={handleFilter}
        className={`${mobilefilter.filterToggle} rounded-circle border-0 d-block d-md-none`}
      ></Button> */}
      {/* <div className='w-100 d-flex mb-3'>
        <CustomSelect
          options={MATCH_TYPE}
          labelKey="sLabel"
          valueKey="sValue"
          defaultValue={MATCH_TYPE[0]}
          isMedium={true}
          onChange={(e) => {
            handleCategoryFilter(e?.sValue)
          }}
        />
      </div> */}

      <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} text-uppercase`} variant="pills">
        {MATCH_TYPE.map((type) => {
          return <Nav.Item className={navStyles.item} key={type.sValue}>
           <a className={` ${sLabel === type.sValue && navStyles.active} text-capitalize nav-link`} onClick={() => {
             handleCategoryFilter(type.sValue)
           }} >
           {type.sLabel}
           </a>
         </Nav.Item>
        })}
      </Nav>

      <DateSlider monthArray={monthArray} selectedMonth={payloads.current.dByMonth} handleYear={handleYear} />
      <FixtureData data={fixtureData} id={fixtureData?._id} />
      {!loading && fixtureData?.length === 0 && <NoData title="Quiet now, but the action is just around the corner. Keep your gear ready!" />}
      {loading && fixtureLoader()}
    </div>
  )
}

ScheduleContent.propTypes = {
  data: PropTypes.object,
  filterData: PropTypes.object
}
